export default function redirectToAztec(quotationId?: string) {
  const { REACT_APP_AZTEC_URL: aztecUrl } = process.env;

  if (aztecUrl) {
    window.location.href =
      aztecUrl + (quotationId ? `/?quotationId=${quotationId}` : '');
  }
}
